import {
  KeyboardArrowDown as KeyboardArrowDownIcon,
  KeyboardArrowUp as KeyboardArrowUpIcon,
} from '@mui/icons-material';
import {
  Box,
  Grid,
  styled,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

export const CustomTableHead = styled(TableHead)(
  ({ theme }) => `
        th {
          border-bottom: 2px solid ${theme.palette.brand.black};
          font-weight : 700;
          font-size: 16px;
        }
      `,
);

export const CustomTableCell = styled(TableCell)<{ isdoublewidth: string }>`
  flex: 1;
  font-size: 16px;
  max-width: 180px;

  & a {
    color: inherit;
  }
`;

export const CustomTableCellRight = styled(TableCell)<{
  isdoublewidth: string;
}>`
  width: 10px;
  font-size: 16px;
  text-align: right;

  & a {
    color: inherit;
  }
`;

export const ArrowIcon = styled(Box)`
  height: 20px;
  cursor: pointer;
`;

export const KeyboardArrowUpIconStyled = styled(KeyboardArrowUpIcon, {
  shouldForwardProp: (prop: any) => {
    return prop !== 'active';
  },
})<{
  active: boolean;
  theme: { palette: { primary: { main: string } } };
}>(({ active, theme }) => ({
  color: active ? theme.palette.primary.main : 'inherit',
  fontSize: '20px',
}));

export const KeyboardArrowDownIconStyled = styled(KeyboardArrowDownIcon, {
  shouldForwardProp: (prop: any) => {
    return prop !== 'active';
  },
})<{
  active: boolean;
  theme: { palette: { primary: { main: string } } };
}>(({ active, theme }) => ({
  color: active ? theme.palette.primary.main : 'inherit',
  fontSize: '20px',
}));

export const CustomTableRow = styled(TableRow)(
  ({ theme }) => `
     border-bottom: 1px solid ${theme.palette.brand.disable};
    `,
);

export const TableBodyContainer = styled(TableContainer)`
  height: 92vh;
  overflow: auto;
`;

export const InViewBoxContainer = styled(Box)`
  height: 50px;
`;

export const ButtonWrapper = styled(Box)`
  position: fixed;
  right: 30px;
  top: 30px;
`;

export const StyledGridContainer = styled(Grid)({
  width: '100%',
});

export const StyledGridItem = styled(Grid)({
  width: '50%',
});

export const StyledGridItemLastChild = styled(Grid)({
  marginLeft: 'auto',
});
